module.exports = __webpack_public_path__ + "img/Groupe 85.43345fca.svg";